	export enum OrderStatusEnum {
		OnTrial = 1,
		Ordered = 2,
		Received = 3,
		Fulfilled = 4,
		Canceled = 5,
		Open = 6,
		PartiallyOnTrial = 7,
		PartiallyFulfilled = 8,
		ReadyToFulfill = 9,
		Returned = 10,
		Exchanged = 11,
		NoSale = 12,
		Voided = 13
	}
